import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { useOverSiteControllerPeopleNum } from "./_hooks";
import { QuestionRoomDynamicPriceSettings } from "./dynamic-price-settings";
import { QuestionRoomOverSiteControllerPeopleNumType } from "./over-site-controller-people-num-type";
import { StaticPriceSettings } from "./static-price-settings";

export const QuestionRoomOverSiteControllerPeopleNum = () => {
	const {
		onSetOverSiteControllerPeopleNumType,
		overSiteControllerPeopleNumType,
		overSiteControllerPeopleNumTypeOptions,
		overSiteControllerPeopleNum,
	} = useOverSiteControllerPeopleNum();

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"サイトコントローラーで設定できない人数の料金"}
			guide="部屋の定員がサイトコントローラーで料金設定できる人数を超過する場合、超過分の料金の設定ができます。"
			isEdited={overSiteControllerPeopleNum?.isEdited ?? false}
			hasError={overSiteControllerPeopleNum?.hasError ?? false}
			inputChildren={
				<div className="flex flex-col gap-y-8">
					<div className="flex flex-col gap-y-4">
						<QuestionRoomOverSiteControllerPeopleNumType
							onSetOverSiteControllerPeopleNumType={onSetOverSiteControllerPeopleNumType}
							overSiteControllerPeopleNumType={overSiteControllerPeopleNumType}
							overSiteControllerPeopleNumTypeOptions={overSiteControllerPeopleNumTypeOptions}
						/>
						<StaticPriceSettings overSiteControllerPeopleNumType={overSiteControllerPeopleNumType} />
						<QuestionRoomDynamicPriceSettings
							overSiteControllerPeopleNumType={overSiteControllerPeopleNumType}
						/>
					</div>
				</div>
			}
		/>
	);
};

QuestionRoomOverSiteControllerPeopleNum.displayName = "QuestionRoomOverSiteControllerPeopleNum";
